import { MARQUEE } from "@/data/content";
import { Lotus } from "./Ornaments";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-display text-4xl sm:text-6xl px-8 whitespace-nowrap ${i % 2 ? "italic text-terra" : "text-ink"}`}>{w}</span>
        <Lotus className="w-10 h-7" color={i % 3 === 0 ? "#D5AD66" : i % 3 === 1 ? "#E8A0A8" : "#8E9D78"} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="py-10 sm:py-14 border-y border-terra/15 bg-cream overflow-hidden" aria-label="Occasions we plan">
    <div className="flex w-max marquee-track">
      <Row />
      <Row />
    </div>
  </section>
);
